(function() {
    'use strict';

    /* this is quite generic controller which can be used in most of the cases */
    /* you can use this code to create your custom controller and pass it with modal-controller to xms-modal */
    var ViewCvCtrl = function (helperFactory, $scope, $uibModalInstance, passedModel, ajaxCall, xmsNotificationFactory, $sce) {
        $scope.angularHelper = helperFactory;
        // $uibModalInstance: same from ui bootstrap
        // passedModel is the modal ng-model passed via directive (object copy)
        if (!angular.isDefined(passedModel)) {
            passedModel = {}; // otherwise any ng-init inside modal will create the model in it's own child scope (inaccessible)
        }

        // your code
        $scope.ngModel = passedModel; // whatever you need to use in the template - you may name your template model ngModel
        // $scope.formModel = passedModel; // or formModel - just mind it will be different formModel than rest of the page (just name share)

        $scope.ok = function () {
            $uibModalInstance.close(this.ngModel); // returnValue - the results will be passed back to xms-modal ng-model (passedModel)
        };
        $scope.cancel = function (e) {
            if (angular.isDefined(e)) {
                e.preventDefault();
            }

            // Passing on ngModel to track offset of pages in search to mactch with cv (X3-9920)
            if (angular.isDefined(this.ngModel.offset)) {
                $uibModalInstance.close(this.ngModel);
            } else {
                $uibModalInstance.dismiss('cancel');
            }
        };

        $scope.saveTags = function(){
            var cvModel = $scope.ngModel;
            var notification = "<div class=\"alert alert-success\" role=\"alert\" aria-live=\"assertive\">Tags Saved Successfully</div>"
            var data = 'oldTags=' + encodeURIComponent(cvModel.oldTags) + '&newTags=' + encodeURIComponent(cvModel.newTags) + '&id=' + cvModel.id;
            var ajaxUrl = WEBAPP_PATH + "/cvAttachment2/saveCandidateTags";
            ajaxCall.getData(ajaxUrl, data).then(
                function(result){
                    $scope.divTags = $sce.trustAsHtml(notification);
                    $scope.ngModel.showSuccess = true;
                }
            );
        };

    };
    ViewCvCtrl.$inject = ['helperFactory', '$scope', '$uibModalInstance', 'params', 'ajaxCall' , 'xmsNotificationFactory', '$sce'];
    angular.module('app').controller('ViewCvCtrl',ViewCvCtrl);
}());
